import { Api } from '@axiom/ui';
import type {
  Candidate,
  CandidateLanguage,
  CandidateLanguageUpdate,
} from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';

class TalentLanguagesApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiEnvoyUrl,
    });
  }

  readLanguages(candidateId: Candidate['id']) {
    return super.read<{
      data: CandidateLanguage[];
    }>({
      endpoint: `/candidates/${candidateId}/languages`,
      method: 'GET',
    });
  }

  async updateLanguages(
    candidateId: Candidate['id'],
    body: Array<Partial<CandidateLanguageUpdate>>
  ) {
    return super.write<boolean>({
      endpoint: `/candidates/${candidateId}/languages`,
      body,
      method: 'PUT',
    });
  }

  async refreshLanguages(candidateId: Candidate['id']) {
    return super.invalidate(`/candidates/${candidateId}/languages`);
  }
}

export const TalentLanguagesApi = new TalentLanguagesApiClass();
